import { useMemo, useState, Dispatch, SetStateAction } from 'react';

const MAX_LENGTH = 100;
const TRIMMED_LENGTH = MAX_LENGTH - 3; // ...

/* Types */
type UseReadMore = [
  {
    text: string;
    collapsed: boolean;
    couldReadMore: boolean;
  },
  Dispatch<SetStateAction<boolean>>,
];

const useReadMore = (text: string, max = MAX_LENGTH): UseReadMore => {
  const couldReadMore = text.length >= max;
  const [collapsed, setCollapsed] = useState<boolean>(couldReadMore);
  const adjusted = useMemo(() => (collapsed ? `${text.substring(0, TRIMMED_LENGTH).trim()}...` : text), [collapsed, text]);

  return [{ text: adjusted, collapsed, couldReadMore }, setCollapsed];
};

export default useReadMore;
